import { Modal } from '@/ui/Modal';

type JourneyInsightsBulkParticipantsRemovalModalProps = {
  onClose: () => void;
  open: boolean;
  onDelete: () => void;
  deleteLoading?: boolean;
};

export const JourneyInsightsBulkParticipantsRemovalModal = ({
  onClose,
  open,
  onDelete,
  deleteLoading,
}: JourneyInsightsBulkParticipantsRemovalModalProps): React.ReactElement => {
  return (
    <Modal open={open} onClose={onClose} size="mobile">
      <Modal.Title>Remove learners</Modal.Title>
      <Modal.Contents>
        You will lose all progress data for the selected learners. This cannot be undone.
        <br />
        <br />
        Are you sure you want to remove these learners from the learning journey?
      </Modal.Contents>
      <Modal.Actions>
        <Modal.Action action={onClose}>Cancel</Modal.Action>
        <Modal.Action variant="primaryDanger" action={onDelete} disabled={deleteLoading}>
          Remove
        </Modal.Action>
      </Modal.Actions>
    </Modal>
  );
};
